

export default () => {
    // Author page (no header)
    $(".author-page").find(".cards-authors").addClass("hidden");
    $(".author-page").find(".profile-author").removeClass("hidden");
    $(".author-page").find(".author-more-recent").removeClass("hidden");
    $(".author-page .bar-authors").find(".cont-letters .letter").on("click", function(){
        $(".profile-author").removeClass("hidden");
        $(".profile-author").find(".surname-name-author, > div:not(.cont-tabs-author)").addClass("hidden");
    });

    // Tabs author page (articles, commentaries, ...)

    // hide profile and author content
    // $(".bar-authors").find(".cont-letters .letter").on("click", function(){
    //     $(".author-page .container-fluid").find(".author-most-valued, .author-comments, .author-votes, .author-more-recent").addClass("hidden");
    // })

    $(".cont-letters select").on("change", function(){
        $(".author-page .container-fluid").find(".author-most-valued, .author-comments, .author-votes, .author-more-recent").addClass("hidden");
    });

    // visible more recent content (onload)
    $(".authors-container").find(".cards-authors .owl-item").on("click", function(){
        $(".author-more-recent").removeClass("hidden");
        $(".author-page .container-fluid").find(".author-most-valued, .author-comments, .author-votes").addClass("hidden");
        $(".profile-author").find(".surname-name-author, > div:not(.cont-tabs-author)").removeClass("hidden");
    });

    // visible more recent content (onload mobile)
    $(".authors-container").find(".cards-authors .cards-mobile .card-author").on("click", function(){
        $(".author-more-recent").removeClass("hidden");
    });

    // visible more recent content
    $(".tabs-author").find("li:first-child .subsection a:first-child").on("click", function(){
        $(".author-page .container-fluid").find(".author-most-valued, .author-comments, .author-votes").addClass("hidden");
        $(".author-page .container-fluid").find(".author-more-recent").removeClass("hidden");
    });

    // visible most valued content
    $(".tabs-author").find("li:first-child .subsection a:last-child").on("click", function(){
        $(".author-page .container-fluid").find(".author-more-recent, .author-comments, .author-votes").addClass("hidden");
        $(".author-page .container-fluid").find(".author-most-valued").removeClass("hidden");
    });

    // visible articles (more recent or most valued) content
    $(".tabs-author").find("li:first-child > a").on("click", function(){
        if($(this).siblings(".subsection").find("a.active").index() == 0) {
            $(".author-page .container-fluid").find(".author-most-valued, .author-comments, .author-votes").addClass("hidden");
            $(".author-page .container-fluid").find(".author-more-recent").removeClass("hidden");
        }else{
            $(".author-page .container-fluid").find(".author-more-recent, .author-comments, .author-votes").addClass("hidden");
            $(".author-page .container-fluid").find(".author-most-valued").removeClass("hidden");
        }
    });

    // visible commentaries content
    $(".tabs-author").find("li:nth-child(2) a").on("click", function(){
        $(".author-page .container-fluid").find(".author-more-recent, .author-most-valued, .author-votes").addClass("hidden");
        $(".author-page .container-fluid").find(".author-comments").removeClass("hidden");
    });

    // visible votes positive / negative content
    $(".tabs-author").find("li:nth-child(3) .subsection a").on("click", function(){
        $(".author-page .container-fluid").find(".author-most-valued, .author-comments, .author-more-recent").addClass("hidden");
        $(".author-page .container-fluid").find(".author-votes").removeClass("hidden");
    });

    // visible votes positive / negative content (extern tab)
    $(".tabs-author").find("li:nth-child(3) > a").on("click", function(){
        $(".author-page .container-fluid").find(".author-most-valued, .author-comments, .author-more-recent").addClass("hidden");
        $(".author-page .container-fluid").find(".author-votes").removeClass("hidden");
    });
}
